export default "__VITE_ASSET__C5Rr$QnB__"